// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrAppLayout, MrAppMain } from '@ion/components';

import SideNav from 'app/components/side-nav';

import SchemaLibraryPageContextProvider from './SchemaLibraryPageContext';
import SchemaLibraryPageHeader from './SchemaLibraryPageHeader';
import SchemaLibraryMain from './SchemaLibraryMain';
import { useTrackPage } from '@ion/api';

const PAGE_TITLE = 'Schema Library';

export default function SchemaLibraryPage() {
  useTrackPage('schema_library_page_viewed');
  return (
    <SchemaLibraryPageContextProvider>
      <MrAppLayout title={PAGE_TITLE} header={<SchemaLibraryPageHeader />} sideNav={<SideNav />}>
        <MrAppMain>
          <SchemaLibraryMain />
        </MrAppMain>
      </MrAppLayout>
    </SchemaLibraryPageContextProvider>
  );
}
